<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">
		<leftnav mkcode="D" itemcode="D-CYFZ" :smScrennFull="true"></leftnav>
		<span class="screen" @click="drawer2 = true"><i class="el-icon-s-unfold"></i>菜单栏</span>
		<!-- 弹框 -->
		<div class="por" style="background-color: #041034;height:100%;height: 100vh;">
			<!-- 全屏开始 -->
			<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
			<!-- 全屏结束 -->
			<div class="index-swiper centerpage">
				<navIcn :title="title" :indexnum="6" navcode="QYGK" :fulltitle="true" :isShowYear="false"></navIcn>
				<div class="indexflex zhaoshangmap">
					<div class="col2h">
						<div class="qysj_chart1 transparentbg">
							<div id="qysj_chart1"  :style="'height:'+chartsHeight + 'px'"></div>
						</div>
						<div class="qysj_enterprisetrends transparentbg">
							<h3 class="qysj_title">企业行业分布</h3>
							<div id="qysj_entrendschart"  :style="'height:'+chartsHeight + 'px'"></div>
						</div>
					</div>
					<div class="col5 ">
						<div class="qysj_con"  :style="'height:'+chartsHeight + 'px'">
							<div class="qysj_con_titlebox">
								<div class="qysj_con_title	">
									<h2> {{ pagedata.count[0].name }}</h2>
									<!-- <p class="yellfont"> {{qyzs.value}}<span class="qysj_comfont">家</span></p> -->
									<p class="yellfont">{{ pagedata.count[0].value }}<span class="qysj_comfont">家</span>
									</p>
								</div>
							</div>
							<div class="qysj_con_list1">
								<!-- <h3>{{xzqy.name}}</h3>
								<span class="yellfont">{{xzqy.value}}</span> -->
								<h3>{{ pagedata.count[1].name }}</h3>
								<span class="yellfont">{{ pagedata.count[1].value }}</span>
							</div>
							<div class="qysj_con_list2">
								<h3>{{ pagedata.count[2].name }}</h3>
								<span class="yellfont">{{ pagedata.count[2].value }}</span>
							</div>
							<div class="qysj_con_list3">
								<h3>{{ pagedata.count[3].name }}</h3>
								<!-- <span class="yellfont">{{gxqy.value}}</span> -->
								<span class="yellfont">{{ pagedata.count[3].value }}</span>
							</div>
							<div class="qysj_con_list4">
								<h3>{{ pagedata.count[4].name }}</h3>
								<!-- <span class="yellfont">{{gsqy.value}}</span> -->
								<span class="yellfont">{{ pagedata.count[4].value }}</span>
							</div>
							<div class="qysj_con_list5">
								<h3>{{ pagedata.count[5].name }}</h3>
								<!-- <span class="yellfont">{{yzqy.value}}</span> -->
								<span class="yellfont">{{ pagedata.count[5].value }}</span>
							</div>
							<div class="qysj_con_list6">
								<h3>{{ pagedata.count[6].name }}</h3>
								<!-- <span class="yellfont">{{gsgyqy.value}}</span> -->
								<span class="yellfont">{{ pagedata.count[6].value }}</span>
							</div>
						</div>
						<div class="ltqy_conbottom" >
							<div class="qysj_list  transparentbg"  :style="'height:'+(chartsHeight+50) + 'px'">
								<div class="qysj_title" style="height: 90px;">
									<ul class="qysj_nav" >
										<li class="qysjnav-li" v-for="(item, i) in pagedata.enterpriseList" :key="i"
											@click="tabnav = i; gettabdata(i, tablist)" :class="tabnav == i ? 'activbg' : ''">
											{{ item.tagName }}</li>
									</ul>
								</div>
								<!-- <div id="qysj_list"></div> -->
								<div class="thbox">
									<ul class="flexcss">
										<li class="th_list1">企业名</li>
										<li class="th_list2">省</li>
										<li class="th_list2">市</li>
										<!-- <li class="th_list2">区/县</li> -->
										<li class="th_list3">行业</li>
									</ul>
								</div>
								<div class="qysj_scrollbox">
									<vue-seamless-scroll :data="qylist" :class-option="defaultOption"
										class="qysj_table_list"> <!-- :data="colors"  :class-option="defaultOption" -->
										<ul class="qysj_tab flexcss" v-for="item in qylist" :key="item.stockCode">
											<!-- v-for="list in pagedata.investList"-->
											<li class="th_list1" @click="routerlinkid('/enterprises', item.stockCode)">
												{{ item.title }}</li>
											<li class="th_list2">{{ userdata.provinceText }}</li>
											<li class="th_list2">{{ item.area }}</li>
											<!-- <li class="th_list2">{{item.pro}}</li> -->
											<li class="th_list3">
												<!-- {{item.notion== ''?'-':item.notion}} -->{{ item.industry }}</li>
										</ul>

									</vue-seamless-scroll>
								</div>


							</div>
						</div>
					</div>
					<div class="col2h">
						<div class="qysj_industries  transparentbg">
							<h3 class="qysj_title">热门产业</h3>
							<div class="ltqy_industries_listbox flexcss" :style="'height:'+(chartsHeight-90) + 'px'">
								<div class="ltqy_industries_list" v-for="item in pagedata.specialIndustry" :key="item.value">
									<h3>{{ item.text }}</h3>
									<p class="bluefont">{{ item.value }}<span class="qysj_comfont">家</span></p>
								</div>
							</div>
							<div class="qysj_regional   transparentbg">
								<h3 class="qysj_title">企业区域分布情况（单位：家）</h3>
								<div id="qysj_regionalchart" :style="'height:'+chartsHeight + 'px'"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import navIcn from "@/components/dataswiper-sass/HNZYB/navIcn.vue";
export default {
	components: { navIcn },
	name: 'zhaoshangditu',
	data() {
		return {
			isCollapse: false,
			isFullscreen: false,
			direction: "ltr",  //btt
			direction2: "btt",  //btt
			drawer: false,
			drawer2: false,
			modal: false,
			title: "重点企业概况",
			bgcolor: "#041034",
			startVal: 0, //数字滚动开始值
			endVal: 1425.44, //数字滚动结束值  
			userdata: {},
			pagedata: { count: [{ name: '', value: '' }, { name: '', value: '' }, { name: '', value: '' }, { name: '', value: '' }, { name: '', value: '' }, { name: '', value: '' }, { name: '', value: '' },] },
			mapurl: 'map/city/321200.json',
			contodefault: {
				duration: 1000,
				autoplay: true,
			},
			islogin: false,
			flag: true,
			swipernum: 3,
			listdata: [],
			public_tooltip: {
				trigger: 'axis',
				backgroundColor: 'rgba(255,255,255,0.9)',
				borderColor: '#ddd',
				borderWidth: '1',
				textStyle: {
					color: '#000',
					fontSize: 14,
				}
			},
			mapurl: 'map/city/321200.json',
			colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#cdae00", "#f87f8f"],
			landType: [],
			startCharts: null,
			//假数据 
			qyzs: { name: '企业总数', value: 0 },
			xzqy: { name: '新增企业', value: 0 },
			cxqy: { name: '创新企业', value: 0 },
			gxqy: { name: '高新技术企业', value: 0 },
			ltqy: { name: '龙头企业', value: 0 },
			yzqy: { name: '优质企业', value: 0 },
			gsgyqy: { name: '规上工业企业', value: 0 },
			yyzz: {},
			gjscb: {},
			xny: {},
			qylist: [
				{ enterprisename: "江苏太平洋精锻科技股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '姜堰区', industry: "金属铸造" },
				{ enterprisename: "江苏扬电科技股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '姜堰区', industry: "变压器" },
				{ enterprisename: "江苏锦鸡实业股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '泰兴区', industry: "染料" },
				{ enterprisename: "江苏森萱医药股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '泰兴区', industry: "医药制造" },
				{ enterprisename: "江苏宝馨科技股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '靖江区', industry: "钣金件" },
				{ enterprisename: "江苏东华测试技术股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '靖江区', industry: "仪器仪表" },
				{ enterprisename: "江苏亚星锚链股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '靖江区', industry: "金属铸造" },
				{ enterprisename: "江苏万林现代物流股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '靖江区', industry: "交通运输、仓储和邮政业" },
				{ enterprisename: "华达汽车科技股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '靖江区', industry: "汽车制造" },
				{ enterprisename: "双乐颜料股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '兴化区', industry: "颜料与染料" },
			],
			tablist: [
				{ name: '上市公司', list: [{ enterprisename: "双乐颜料股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '兴化区', industry: "颜料与染料" },], },
				{ name: '科技小巨人企业', list: [{ enterprisename: "双乐颜料股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '兴化区', industry: "颜料与染料" },], },
				{ name: '独角兽', list: [{ enterprisename: "双乐颜料股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '兴化区', industry: "颜料与染料" },], },
				{ name: '隐形冠军', list: [{ enterprisename: "双乐颜料股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '兴化区', industry: "颜料与染料" },], },
				{ name: '瞪羚企业', list: [{ enterprisename: "双乐颜料股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '兴化区', industry: "颜料与染料" },], },
				{ name: '专精特新', list: [{ enterprisename: "双乐颜料股份有限公司", pro: "江苏省", ctiy: '泰州市', areas: '兴化区', industry: "颜料与染料" },], },
			],
			tabnav: 0,
			chartsHeight: 360,
		}
	},
	props: {
		msg: String,
	},
	computed: {
		defaultOption() {
			return {
				step: 0.7, // 数值越大速度滚动越快
				limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
		}
	},

	mounted() {
		document.getElementById('app').style.background = this.bgcolor;
		this.userdata = this.getuseriformation();
		if (this.userdata.edition < 1) {
			var _this = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.bus.$emit('loading', true);
		this.getajasdata();
		this.chartsHeight = document.body.clientHeight/2.5;
		console.log('页面高度', this.chartsHeight);
	},
	methods: {
		getajasdata() {
			var _this = this;
			// this.bus.$emit('loading', true);
			console.log(this.title);
			this.$axios.get(this.$api.cyl.GovProvinceChart.EnterpriseData(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log('_this.pagedata', res.data.data);
				_this.pagedata = res.data.data;
				_this.tablist = res.data.data.enterpriseList;
				_this.qylist = _this.tablist[0].entList;
				_this.chart1Fun('qysj_chart1', res.data.data.tagList);  //左一
				_this.entrendschartFun('qysj_entrendschart', res.data.data.industryList); //企业行业分布
				_this.regionalchartFun('qysj_regionalchart', res.data.data.areaList); //企业区域分布情况（单位：家） 
				_this.bus.$emit('loading', false);

			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

		gettabdata(i, data) {
			console.log(i, data);
			this.qylist = data[i].entList;
			console.log('1111', this.qylist);
		},
		//chart1 qysj_chart1 
		chart1Fun(el, data) {
			var chart1 = echarts.init(document.getElementById(el));
			var _this = this;
			for (var i = 0; i < data.length; i++) {
				data[i].name = data[i].text;
			}
			// data.push({code: "", name: "瞪羚企业" ,text: "上市公司",value: 20});
			// console.log('data',data);
			var option = {
				// color:this.colors,
				tooltip: {},
				series: [{
					type: 'treemap',
					nodeClick: 'false',  //点击节点不反应 
					roam: 'false',  //不能缩放平移
					itemStyle: {
						// borderWidth:"1"
						gapWidth: '1'  //图像间的间隔
					},
					emphasis: {
						focus: 'self',   //聚焦当前数据
						// blurScope: 'coordinateSystem'
					},
					breadcrumb: { show: false },
					data: data,
					// [
					// {code: "", name: "上市公司" ,text: "上市公司",value: 20},
					// {code: "", name: "隐形冠军" ,text: "隐形冠军",value: 10},
					// {code: "", name: "科技小巨人企业" ,text: "科技小巨人企业",value: 15},
					// {code: "", name: "独角兽企业" ,text: "上市公司",value: 10},
					// {code: "", name: "专精特新" ,text: "上市公司",value: 10},
					// {code: "", name: "瞪羚企业" ,text: "上市公司",value: 20},
					// ],
				}]
			};
			chart1.setOption(option);
		},


		//企业行业分布
		entrendschartFun(el, data) {
			var charPie3currentIndex = 0, isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var regionalchart = echarts.init(document.getElementById(el));
			var _this = this;
			var option = {
				color: this.colors,
				title: {
					text: ' ',
				},
				tooltip: {
					trigger: 'item',
					confine: true, //提示框被遮挡  是否将 tooltip 框限制在图表的区域内
				},
				// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
				// },
				series: [
					{
						name: '',
						type: 'pie',
						radius: '55%',
						center: ["50%", "50%"],
						data: data,
						// 				data: [
						// 					{name:"仪器仪表",value:2497432},
						// 					{name:"汽车制造",value:1659253},
						// 					{name:"智能家居",value:2754018},
						// 					{name:"机器人",value:3061920},
						// 					{name:"农副食品加工",value:3181660},
						// 					{name:"量子通信",value:3951417}, 
						// ],
						label: { show: true, color: '#eee', fontSize: 12, position: 'outside', formatter: '{b} \n {d}%', },
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};
			regionalchart.setOption(option);
			var startCharts = null;
			// // 2、鼠标移动上去的时候的高亮动画
			// hgsj.on('mouseover', function(param) {
			// 	isSet = false
			// 	clearInterval(startCharts)
			// 	// 取消之前高亮的图形
			// 	hgsj.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 高亮当前图形
			// 	hgsj.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// 	// 显示 tooltip
			// 	hgsj.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// });
			// var chartHover = function() {
			// 	var dataLen = option.series[0].data.length
			// 	// 取消之前高亮的图形
			// 	hgsj.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
			// 	// 高亮当前图形
			// 	hgsj.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 显示 tooltip
			// 	hgsj.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// }
			// startCharts = setInterval(chartHover, 2000)
			// // 4、鼠标移出之后，恢复自动高亮
			// hgsj.on('mouseout', function(param) {
			// 	if (!isSet) {
			// 		startCharts = setInterval(chartHover, 2000)
			// 		isSet = true
			// 	}
			// });
		},

		//企业区域分布情况（单位：家）
		regionalchartFun(el, data) {
			var charPie3currentIndex = 0, isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var regionalchart = echarts.init(document.getElementById(el));
			var _this = this;
			var option = {
				color: this.colors,
				title: {
					text: ' ',
				},
				tooltip: {
					trigger: 'item'
				},
				// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
				// },
				series: [
					{
						name: '',
						type: 'pie',
						radius: '55%',
						center: ["50%", "50%"],
						data: data,
						// 				data: [
						// 					{name:"海陵区",value:2497432},
						// 					{name:"高港区",value:1659253},
						// 					{name:"姜堰区",value:2754018},
						// 					{name:"兴化市",value:3061920},
						// 					{name:"靖江市",value:3181660},
						// 					{name:"泰兴市",value:3951417}, 
						// ],
						label: { show: true, color: '#eee', fontSize: 12, position: 'outside', formatter: '{b} \n {d}%', },
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};
			regionalchart.setOption(option);
			var startCharts = null;
			// // 2、鼠标移动上去的时候的高亮动画
			// hgsj.on('mouseover', function(param) {
			// 	isSet = false
			// 	clearInterval(startCharts)
			// 	// 取消之前高亮的图形
			// 	hgsj.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 高亮当前图形
			// 	hgsj.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// 	// 显示 tooltip
			// 	hgsj.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// });
			// var chartHover = function() {
			// 	var dataLen = option.series[0].data.length
			// 	// 取消之前高亮的图形
			// 	hgsj.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
			// 	// 高亮当前图形
			// 	hgsj.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 显示 tooltip
			// 	hgsj.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// }
			// startCharts = setInterval(chartHover, 2000)
			// // 4、鼠标移出之后，恢复自动高亮
			// hgsj.on('mouseout', function(param) {
			// 	if (!isSet) {
			// 		startCharts = setInterval(chartHover, 2000)
			// 		isSet = true
			// 	}
			// });
		},
	}
}
</script>

<style scoped="scoped">
@import url("../../../css/dataswiper.css");
</style>
